export const volumes = [
  {
    number: 'I',
    accent: '#DDE5CC',
    title: 'The 21-Day Reflexology Roadmap',
    intro:
      "Before you begin, I want you to know exactly where you're going. This volume walks you through the entire method and shows you how to use your 21 days without wondering what comes next.",
    listLabel: "Inside you'll find",
    items: [
      'How the 21-day method works',
      'The four-step practice system',
      'How to organize your 15 minutes',
      'How to use each volume',
      'How to structure your daily practice',
      'How to track your progress',
      'How to stay consistent',
      'What to do if you miss a day',
      'Quick-start instructions',
      'Your complete 21-day roadmap',
    ],
    closing: 'This is your map for the entire journey.',
  },
  {
    number: 'II',
    accent: '#CFE6DD',
    title: 'The 7-Day Reflexology Foundation',
    intro:
      "The first seven days are about building your foundation. I've organized each day so you know what to review, what to practice, and what to record.",
    listLabel: 'Each day includes',
    items: [
      'Daily objective',
      'Reflexology concept',
      'Visual review',
      'Practice exercise',
      'Suggested timing',
      'Reflection questions',
      'Daily checklist',
      'Progress tracking',
    ],
    closing: 'You\'ll stop asking "What should I study today?" Because your next step is already waiting for you.',
  },
  {
    number: 'III',
    accent: '#F3D6D1',
    title: 'The 7-Day Reflexology Practice Routine',
    intro:
      "Now it's time to move from studying into practice. I've created a simple daily structure to help you apply what you're learning.",
    listLabel: 'Each practice day includes',
    items: [
      'Daily objective',
      'Preparation',
      'Reference material',
      'Practice exercise',
      'Suggested duration',
      'Observation notes',
      'Practice checklist',
      'Daily reflection',
    ],
    closing: "You don't need to spend hours practicing. You need a clear reason to sit down and begin.",
  },
  {
    number: 'IV',
    accent: '#D3E3F0',
    title: 'The 7-Day Reflexology Consolidation System',
    intro:
      "The final seven days are designed to help you reinforce what you've been studying and practicing. Instead of simply moving on to more information, you'll revisit, review, and connect what you've already learned.",
    listLabel: "Inside you'll find",
    items: [
      'Review exercises',
      'Visual recall exercises',
      'Zone recognition activities',
      'Practice sequences',
      'Mini challenges',
      'Self-assessments',
      'Reflection prompts',
      'Progress reviews',
      'Consolidation checklists',
    ],
    closing:
      "Because learning isn't just about adding more information. It's about remembering and using what you've already learned.",
  },
  {
    number: 'V',
    accent: '#F4DFCB',
    title: 'Your Personal Reflexology Practice System',
    intro:
      "The 21 days eventually come to an end. But I don't want your practice to end with them. That's why I created this volume to help you turn the 21-day method into your own ongoing practice routine.",
    listLabel: "Inside you'll find",
    items: [
      'Personal Practice Planner',
      'Weekly Practice Planner',
      'Monthly Practice Planner',
      'Practice Log',
      'Study Log',
      'Questions Log',
      'Mistake Log',
      'Progress Tracker',
      'Weekly Review',
      'Practice Goals',
      'Personal Notes',
    ],
    closing: "You'll be able to continue using the system long after Day 21.",
  },
  {
    number: 'VI',
    accent: '#DED6EF',
    title: 'The Pocket Reflexology Practice Guide™',
    intro:
      "Your quick-reference companion. I created this volume for those moments when you don't want to open an entire workbook just to find one simple reminder.",
    listLabel: "Inside you'll find",
    items: [
      'Quick-reference pages',
      'Daily practice cards',
      'Mini checklists',
      'Practice sequence',
      'Study prompts',
      'Review prompts',
      '15-minute practice framework',
      'Progress tracker',
      'Practice notes',
      'Mobile-friendly references',
    ],
    closing: 'Open it. Find what you need. Keep practicing.',
  },
];
